<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>又踏层峰辟新天——《中共中央关于进一步全面深化改革、推进中国式现代化的决定》<br>诞生记</h2>
        <p style="text-align: right"><span style="margin-right: 60px">2024-10-09</span></p>
        <p>
          向着全面建成社会主义现代化强国、实现第二个百年奋斗目标奋力前行，党和国家迎来又一个历史性时刻——
        </p>
        <p>
          2024年7月18日下午，如潮掌声中，党的二十届三中全会正式通过《中共中央关于进一步全面深化改革、推进中国式现代化的决定》。
        </p>
        <p>
          站在继往开来的历史关口，又一次具有里程碑意义的重要会议胜利召开，新时代新征程进一步全面深化改革的冲锋号角响彻神州大地。
        </p>
        <p>
          以习近平同志为核心的党中央团结带领全党全军全国各族人民矢志不渝、勇毅前行，以进一步全面深化改革开辟中国式现代化广阔前景，将强国建设、民族复兴伟业不断推向前进。
        </p>
        <p class="blue01">
          高擎改革旗帜 作答时代课题——着力解决影响中国式现代化的体制机制问题，用好改革开放重要法宝，将改革进行到底
        </p>
        <p>
          2024年4月底，一则重磅消息通过新华社的电波，传遍大江南北——
        </p>
        <p>
          “中共中央政治局4月30日召开会议，决定今年7月召开党的二十届三中全会，重点研究进一步全面深化改革、推进中国式现代化问题。”
        </p>
        <p>
          “中国政治日程表上最重要的会议之一”“改革开放以来，历届三中全会都聚焦改革议题，为中国未来五到十年的发展作出谋划部署，因此尤为令人期待”……海内外关注的目光，纷纷投向中国共产党历史上的又一次三中全会——二十届三中全会。
        </p>
        <p>
          三中全会，在亿万中华儿女心中具有沉甸甸的分量。
        </p>
        <p>
          党的十一届三中全会是划时代的，开启了改革开放和社会主义现代化建设新时期。
        </p>
        <p>
           党的十八届三中全会以来，习近平总书记以伟大的历史主动、巨大的政治勇气、强烈的责任担当，亲自谋划、亲自部署、亲自推动全面深化改革，带领全党全军全国各族人民以前所未有的力度开辟事业发展新天地，中华民族伟大复兴进入不可逆转的历史进程。
          放眼全世界，没有哪个国家和政党，能有这样的政治气魄和历史担当，敢于大刀阔斧、刀刃向内、自我革命，没有哪个国家和政党，能在这么短时间内推动这么大范围、这么大规模、这么大力度的改革，也没有哪个国家和政党，能在改革进程中取得这样的历史性变革、系统性重塑、整体性重构。
        </p>
        <p>
          回望新时代以来全面深化改革的成功实践和伟大成就，我们更加深切感悟到，党的十八届三中全会也是划时代的，开启了新时代全面深化改革、系统整体设计推进改革新征程，开创了我国改革开放全新局面。
        </p>
        <p>
          时光是忠实的见证者，人民是伟大的书写者。
        </p>
        <p>2022年金秋，习近平总书记在党的二十大报告中向世界庄严宣告——</p>
        <p>“从现在起，中国共产党的中心任务就是团结带领全国各族人民全面建成社会主义现代化强国、实现第二个百年奋斗目标，以中国式现代化全面推进中华民族伟大复兴。”</p>
        <p>壮阔的复兴航程，标注下又一个崭新的奋斗坐标。</p>
        <p>“新征程上，靠什么来进一步凝心聚力、汇聚起推进中华民族伟大复兴的强大力量？答案就是靠中国式现代化。”习近平总书记以马克思主义政治家、思想家、战略家的深刻洞察力、敏锐判断力、理论创造力，指明前进方向。</p>
        <p>当前和今后一个时期，是以中国式现代化全面推进强国建设、民族复兴伟业的关键时期。我们面临的形势环境之复杂前所未有，肩负的改革发展任务之艰巨前所未有，中国之问、世界之问、人民之问、时代之问向我们提出更加艰深的考题。</p>
        <p>继往开来的关键时刻，如何团结带领14亿多中国人民迎难而上、接续奋斗，在危机中育新机、于变局中开新局？</p>
        <p>人民期盼中国共产党人的选择，时代瞩目中国共产党人的答卷。</p>
        <p>
          这次三中全会研究什么议题、作出什么决定、采取什么举措、释放什么信号，党的二十大闭幕之后，习近平总书记就进行着深入思考。
        </p>
        <p>“改革开放和社会主义现代化建设新时期，我国大踏步赶上时代，靠的是改革开放。”</p>
        <p>“党的十八大以来，党和国家事业取得历史性成就、发生历史性变革，靠的也是改革开放。”</p>
        <p>“新时代新征程上，要开创中国式现代化建设新局面，仍然要靠改革开放。”</p>
        <p>登高望远、拨云见日，习近平总书记的判断清醒而坚定。</p>
        <p>在历史前进的逻辑中前进方为人间正道，在时代发展的潮流中发展才能更上层楼——</p>
        <p>凝聚人心、汇聚力量，实现新时代新征程党的中心任务，迫切需要进一步全面深化改革；</p>
        <p>完善和发展中国特色社会主义制度、推进国家治理体系和治理能力现代化，迫切需要进一步全面深化改革；</p>
        <p>推动高质量发展、更好适应我国社会主要矛盾变化，迫切需要进一步全面深化改革；</p>
        <p>应对重大风险挑战、推动党和国家事业行稳致远，迫切需要进一步全面深化改革……</p>
        <p>2023年11月，中共中央政治局常委会、中共中央政治局先后召开会议，作出一项意义重大、影响深远的重大决策——党的二十届三中全会重点研究进一步全面深化改革、推进中国式现代化问题并作出决定。</p>
        <p>同时，成立党的二十届三中全会文件起草组，习近平总书记亲自担任文件起草组组长。</p>
        <p>党的二十届三中全会主题，为何确定为进一步全面深化改革、推进中国式现代化？</p>
        <p>习近平总书记一语道破要旨：“就是要向国内国际释放我们坚定不移高举改革开放旗帜的强烈信号。”</p>
        <p>拉开历史的长镜头，站在党和国家事业发展全局眺望，更能读懂这个主题蕴含的深意。</p>
        <p>推进中国式现代化必须进一步全面深化改革——</p>
        <p>
          中国式现代化是一项前无古人的开创性事业，艰巨性和复杂性前所未有，前进道路上必然会遇到各种不确定、难预料的风险挑战。当前，世界百年变局加速演进，新一轮科技革命和产业变革深入发展，世界进入新的动荡变革期。我国发展战略机遇和风险挑战并存，发展不平衡不充分问题仍然突出，不少深层次矛盾躲不开、绕不过。解决、回应这些矛盾问题，必须靠进一步全面深化改革。
        </p>
        <p>进一步全面深化改革必须聚焦中国式现代化——</p>
        <p>围绕党的中心任务谋划和部署改革，是党领导改革开放的成功经验。以中国式现代化全面推进强国建设、民族复兴伟业是新时代新征程党的中心任务，进一步全面深化改革必须紧紧围绕推进中国式现代化来谋划和展开，确保目标明确、有的放矢。
        </p>
        <p>进一步全面深化改革与推进中国式现代化，紧密联系、内在统一。</p>
        <p>
          正如习近平总书记所言：“党的二十大对推进中国式现代化作了战略部署。要把这些战略部署落到实处，把中国式现代化蓝图变为现实，根本在于进一步全面深化改革，不断完善各方面体制机制，扫除各种障碍，源源不断为中国式现代化激发活力、增添动力。”
        </p>
        <p>题定纲成，乘势而进。</p>
        <p>在一次次考察调研、一场场座谈交流中，习近平总书记深刻阐明进一步全面深化改革、推进中国式现代化的重大意义、指导原则、目标任务、重大举措、科学路径等重大理论和实践问题，为做好全会文件起草工作提供有力指引。</p>
        <p>
          习近平总书记明确指出，全会要抓住推进中国式现代化需要解决的重大体制机制问题、深层次矛盾和问题，深入研究、深化认识、找准症结，科学谋划改革的战略重点、优先顺序、主攻方向、工作机制、推进方式，在此基础上形成进一步全面深化改革的总体部署。
        </p>
        <p>
          “要顺应时代发展新趋势、实践发展新要求、人民群众新期待，以改革到底的坚强决心，不绕道、不回避，动真格、敢碰硬，坚决清除一切妨碍中国式现代化顺利推进的体制机制障碍和制约因素，努力形成精准发力、协同发力、持续发力、扎实推进中国式现代化的生动局面。”
        </p>
        <p>改革大旗高高举起，时代大潮势不可挡。</p>
        <p class="blue01">汇集众智民意 凝聚信心共识——文件起草工作始终在以习近平同志为核心的党中央领导下进行，发扬民主、集思广益贯穿全过程。</p>
        <p>2023年12月8日，北京中南海。习近平总书记主持召开党的二十届三中全会文件起草组第一次全体会议。</p>
        <p>
          “党中央把起草党的二十届三中全会文件这项重大任务交给大家，是对大家的充分信任，也是大家的荣誉和责任。”面对在场的70多名文件起草组同志，习近平总书记提出要求：“希望大家以对党忠诚、高度负责的精神，同心协力、扎实工作，完成党中央交给的全会文件起草任务。”
        </p>
        <p>此后的200多个日日夜夜，文件起草工作紧锣密鼓，全力以赴拿出一份能够在新时代新征程上凝聚起全党全国各族人民磅礴力量的改革文件。</p>
        <p>
          进一步全面深化改革，是在改革开放40多年特别是新时代以来全面深化改革取得重大成就基础上推进的。文件起草工作启动之初，大家就在深入思考：各领域面临的主要问题究竟是什么？推进中国式现代化需要解决哪些体制机制问题、深层次矛盾和问题？
        </p>
        <p>“党中央作出重大决策部署，都要广泛发扬民主，集中全党全国智慧。这也是我们起草党的重要文件的一条成功经验。”习近平总书记多次强调：“要把发扬民主、集思广益贯穿文件起草工作全过程。”</p>
        <p>2023年11月底，党中央下发通知，就党的二十届三中全会议题在党内一定范围征求意见。同时，通过一定方式征求部分党外人士意见和建议。</p>
        <p>不久，带着对党情国情世情的调研思考，凝结着各方面的智慧，111份意见和建议从四面八方汇集而来。</p>
        <p>调研先行，意在笔先。</p>
        <p>进一步全面深化改革，必须在深入调查研究的基础上，摸清家底、找准问题，做到靶向发力、精准求解。</p>
        <p>平畴沃野、碧水绕田。2024年3月19日，正值春耕备耕时节，习近平总书记来到湖南省常德市鼎城区谢家铺镇粮食生产万亩综合示范片区，仔细察看农情，同种粮大户、农技人员等亲切交流……</p>
        <p>春耕、夏耘、秋收、冬藏，习近平总书记在多次地方考察中关注“中国饭碗”，站在广袤的大地上思索强农惠农富农和农村改革问题。</p>
        <p>沉下来、钻进去，在改革开放伟大实践里寻找答案——习近平总书记身体力行、率先垂范。</p>
        <p>
          沿着总书记指引的方向，文件起草组持续深入学习领会习近平新时代中国特色社会主义思想特别是习近平总书记关于全面深化改革的一系列新思想、新观点、新论断，研究思考如何将总书记思想、党中央意图、新时代要求通过进一步全面深化改革落实到位。
        </p>
        <p>同时，按照习近平总书记的要求和党中央安排，文件起草组认真开展调查研究，在调研中进一步深入思考、消化吸收，汇聚各方面智慧，形成更集中的改革聚焦点。</p>
        <p>2023年12月，召开全会重点课题调研部署会议，安排55家中央有关部门和单位就38个重点课题进行调研，此后形成78份调研报告；同时，组成16个调研组，赴各省区市、新疆生产建设兵团和中央有关部门、单位调研。</p>
        <p>2023年12月下旬起，就全会议题上门听取党和国家有关领导同志以及省部级主要领导同志的意见，一对一单独访谈，并形成一人一稿的访谈记录。</p>
        <p>习近平总书记对党和国家领导同志意见及省部级主要负责同志访谈报告逐一审看，对重要意见建议还作了批注。</p>
        <p>直接调研、委托部门和机构调研、进行专题论证、听取专家意见……一个个重大改革命题，正是在这样的调研过程中不断得出答案。</p>
        <p>进一步全面深化改革往什么方向走，这是一个带有根本性的问题。</p>
        <p>
          对此，习近平总书记坚定地说：“要坚持守正创新，改革无论怎么改，坚持党的全面领导、坚持马克思主义、坚持中国特色社会主义道路、坚持人民民主专政等根本的东西绝对不能动摇，同时要敢于创新，把该改的、能改的改好、改到位，看准了就坚定不移抓。”
        </p>
        <p>在习近平总书记心中，全会决定“应该是一个能够对进一步全面深化改革起到全局性、引领性作用的文件，必须更加突出重点，把重心放在事关中国式现代化具有战略性的重大改革举措上”。</p>
        <p>“一般性改革举措不写、发展性举措不写、中央已经部署正在实施的改革举措不写，力争让决定稿的改革成色更足、改革味更浓。”</p>
        <p>从习近平总书记重要讲话、相关重要文件、各地区各部门各单位反馈意见建议、专题调研报告、访谈材料、课题研究报告等材料中，系统梳理有关领域的重要改革举措，汇总形成改革举措台账和清单，为决定稿的起草提供坚实的理论和实践依据。
        </p>
        <p>披沙拣金，选其要者。经反复比选、研究论证，在突出战略性、前瞻性的同时，注重改革举措的针对性、可操作性，将党和国家事业发展最需要、人民群众最期盼、对推进经济社会发展最紧迫、现实条件最具备的重大改革举措纳入文件。</p>
        <p>根据习近平总书记关于做好重要改革举措研究论证的重要指示要求，先后就21项改革举措，委托53家部门和单位组织论证，并根据论证结果甄别遴选——</p>
        <p>对于共识度较高的改革举措，相关部门和单位均表示赞成的，果断纳入；</p>
        <p>对于共识度较高、但在具体表述上需要进一步完善的改革举措，根据相关意见建议认真研究吸收，对表述进行修改完善。</p>
        <p>2024年5月7日，决定征求意见稿下发，广泛征求各方面意见。</p>
        <p>“今天召开座谈会，就是想当面听一听大家的意见和建议。”5月20日，习近平总书记主持召开党外人士座谈会，听取各民主党派中央、全国工商联负责人和无党派人士代表对决定稿的意见和建议。</p>
        <p>
          会上，习近平总书记认真记录、不时插话，同大家深入交流。会议结束时，总书记叮咛：“今天的座谈会后，大家可以继续深入思考和研究，把各领域值得关注的情况和各方面反映较为集中的意见建议汇集起来，及时向中共中央反映，为开好中共二十届三中全会作出积极贡献。”
        </p>
        <p>几天后，习近平总书记又在山东济南主持召开企业和专家座谈会，听取了大家就深化电力体制改革、发展风险投资、用科技改造提升传统产业、优化外资企业营商环境等方面的意见建议。</p>
        <p>细心的人们不难发现，出席座谈会的企业代表中不仅有国有企业、民营企业代表，还有外资企业代表，改革文件的出台汇聚起最广泛的民意和智慧。</p>
        <p>几上几下、反复修改。7个多月时间里，对决定稿认真推敲、细致打磨，过程稿多达38次。从重大论断、重大举措，到文字表述、遣词用句，力争务实严谨、精准到位。</p>
        <p>截至5月30日，各地区各部门各方面共提出修改意见1911条，扣除重复意见后为1756条，其中原则意见135条，具体修改意见1621条。</p>
        <p>经过认真研究这些意见和建议，能吸收的尽量吸收，作出221处修改。</p>
        <p>决定起草的过程，是谋划改革、推动改革的过程，也是鼓舞人心、昂扬斗志的过程。</p>
        <p>其间，习近平总书记3次主持召开中央政治局常委会会议、2次主持召开中央政治局会议审议全会有关文件，精心审阅批改文件起草组上报的每一稿，多次作出重要指示批示。</p>
        <p>一遍遍推敲、论证、研究，一次次修改、丰富、完善，决定稿在夜以继日的反复打磨中日渐成熟。</p>
        <p>7月15日上午，这份承载历史使命、汇聚党心民意的文件，摆放在了出席党的二十届三中全会的各位同志面前。习近平总书记就《决定（讨论稿）》向全会作了说明。</p>
        <p>出席全会的199名中央委员、165名候补中央委员，还有列席会议的同志，分成10个组，深入交流讨论、提出意见建议。</p>
        <p>经过充分讨论，与会同志共提出修改意见205条。文件起草组根据这些意见建议，对讨论稿提出修改建议。</p>
        <p>7月17日晚，习近平总书记主持召开中央政治局常委会会议，听取全会各组讨论情况汇报和文件起草组修改建议，对决定稿作出25处修改。形成的修改稿于18日上午再次提交全会分组征求意见，之后又作出2处修改，形成《决定》草案。
        </p>
        <p>
          与会同志一致表示，《决定》主题鲜明、凝心聚力，布局合理、重点突出，方向明确、措施具体，充分体现了以习近平同志为核心的党中央进一步全面深化改革、推进中国式现代化的坚强决心、政治担当和历史主动，是对新时代新征程举什么旗、走什么路的再宣示，必将为强国建设、民族复兴伟业注入强劲动力。
        </p>
        <p>
          与会同志一致认为，在新时代以来全面深化改革的成功实践和伟大成就基础上继续前进，我们底气十足、信心满怀。有习近平总书记作为党中央的核心、全党的核心领航掌舵，有习近平新时代中国特色社会主义思想科学指引，中国号巨轮必将劈波斩浪，以进一步全面深化改革开辟中国式现代化光明前景。
        </p>
        <p class="blue01">绘就改革宏图 再启时代新篇——以钉钉子精神抓好改革落实，把进一步全面深化改革的战略部署转化为推进中国式现代化的强大力量。</p>
        <p>“通过！”</p>
        <p>7月18日下午，人民大会堂。习近平总书记话音甫落，会场响起经久不息的热烈掌声。</p>
        <p>
          这是党的十八届三中全会以来全面深化改革的实践续篇，也是新征程推进中国式现代化的时代新篇。在推进强国建设、民族复兴伟业的关键时期，《决定》深入分析了推进中国式现代化面临的新情况新问题，科学谋划了围绕中国式现代化进一步全面深化改革的总体部署，在新征程上高高举起改革开放伟大旗帜。
        </p>
        <p>2万余字的文件，勾画百年大党风华正茂、坚毅笃行的改革蓝图，见证中华儿女勇往直前、拼搏奋斗的铿锵足音。</p>
        <p>
          《决定》共15部分，可分为“1+13+1”三大板块。第一板块是总论，主要阐述进一步全面深化改革、推进中国式现代化的重大意义和总体要求。第二板块是分论，以经济体制改革为牵引，全面部署各领域各方面的改革。第三板块主要讲加强党对改革的领导、深化党的建设制度改革。
        </p>
        <p>人们注意到，决定稿共60条，恰与党的十八届三中全会60条举措呼应衔接，同时又在理论和实践上体现出鲜明特点。</p>
        <p>坚持目标导向，贯穿和体现中国式现代化主题——</p>
        <p>
          站在新的历史起点，《决定》明确了进一步全面深化改革的总目标：继续完善和发展中国特色社会主义制度，推进国家治理体系和治理能力现代化。到二〇三五年，全面建成高水平社会主义市场经济体制，中国特色社会主义制度更加完善，基本实现国家治理体系和治理能力现代化，基本实现社会主义现代化，为到本世纪中叶全面建成社会主义现代化强国奠定坚实基础。
        </p>
        <p>这一总目标，既同党的十八届三中全会确定的全面深化改革总目标一脉相承，又同党的二十大作出的战略部署相衔接，为进一步全面深化改革明确了目标导向。</p>
        <p>
          《决定》紧紧围绕推进中国式现代化、落实党的二十大战略部署精心设计，提出聚焦构建高水平社会主义市场经济体制、聚焦发展全过程人民民主、聚焦建设社会主义文化强国、聚焦提高人民生活品质、聚焦建设美丽中国、聚焦建设更高水平平安中国、聚焦提高党的领导水平和长期执政能力“七个聚焦”，从总体上囊括了推进中国式现代化的战略重点。
        </p>
        <p>确保改革航船稳舵前行，《决定》提出了进一步全面深化改革必须贯彻好“六个坚持”原则：坚持党的全面领导、坚持以人民为中心、坚持守正创新、坚持以制度建设为主线、坚持全面依法治国、坚持系统观念。</p>
        <p>“六个坚持”原则，是对改革开放以来特别是新时代全面深化改革宝贵经验的科学总结，在进一步全面深化改革中必须认真贯彻。</p>
        <p>突出改革重点，抓住进一步全面深化改革的“牛鼻子”——</p>
        <p>经济体制改革是进一步全面深化改革的牵引。《决定》13个部分的分论中，涉及经济领域的就有6个部分，足见其分量之重。</p>
        <p>《决定》把构建高水平社会主义市场经济体制摆在突出位置，抓住经济体制改革的重点领域和关键环节，牵引和带动其他改革：</p>
        <p>推进国有经济布局优化和结构调整，制定民营经济促进法，防止和纠正利用行政、刑事手段干预经济纠纷，清理和废除妨碍全国统一市场和公平竞争的各种规定和做法，对侵犯各种所有制经济产权和合法利益的行为实行同责同罪同罚……</p>
        <p>同时，《决定》提出健全因地制宜发展新质生产力体制机制，加强新领域新赛道制度供给，建立未来产业投入增长机制，深化财税体制改革，增加地方自主财力，拓展地方税源等举措，以改革进一步塑造发展动能、激发经济活力。</p>
        <p>
          不仅仅是经济领域，政治、文化、社会、生态文明、国家安全、国防和军队……《决定》坚持需求导向与问题导向相统一，抓住主要矛盾，增强前瞻性、可操作性，通过改革有效破除推进中国式现代化面临的各方面问题和风险挑战，推动生产关系和生产力、上层建筑和经济基础、国家治理和社会发展更好相适应。
        </p>
        <p>坚持人民至上，从人民整体利益、根本利益、长远利益出发谋划和推进改革——</p>
        <p>翻开《决定》全文，发现学生实习实践这件貌似不起眼的小事，也写入了中央文件。</p>
        <p>老百姓关心什么、期盼什么，改革就要抓住什么、推进什么。《决定》提出的一系列改革举措，是发展所需，更是民心所向，不断满足人民对美好生活的向往：</p>
        <p>
          健全灵活就业人员、农民工、新就业形态人员社保制度，全面取消在就业地参保户籍限制，加快构建房地产发展新模式，健全人口发展支持和服务体系，完善生育支持政策体系和激励机制，按照自愿、弹性原则稳妥有序推进渐进式延迟法定退休年龄改革……
        </p>
        <p>以人民为中心的发展思想，在进一步全面深化改革中绽放更加耀眼的光芒。</p>
        <p>注重系统集成，各方面改革相互配合、协同高效——</p>
        <p>
          善弈者谋势，善谋者致远。作为一份对党和国家事业发展具有全局性和长远性指导作用的政治文件，《决定》从党和国家工作大局出发提出改革举措，谋划具有基础性和牵引作用的重大举措，加强各项改革举措的协调配套，加强相关领域相近改革举措的整合。
        </p>
        <p>
          《决定》的一个鲜明特点就是更加注重系统集成，以推进中国式现代化的目标任务和重大问题为提领，在统筹推进“五位一体”总体布局、协调推进“四个全面”战略布局框架下谋划进一步全面深化改革，加强对改革的整体谋划、系统布局，确保改革更加凝神聚力、协同高效。
        </p>
        <p>以“构建支持全面创新体制机制”为例，《决定》统筹推进教育科技人才体制机制一体改革，推动各领域各部分改革举措同向发力、形成合力，提升国家创新体系整体效能。</p>
        <p>强化政治保障，以党的自我革命引领伟大社会革命——</p>
        <p>办好中国的事情，关键在党。进一步全面深化改革、推进中国式现代化，必须不断提高党的领导水平，切实加强和改进党的建设。</p>
        <p>《决定》专门用一个部分部署党的领导和党的建设制度改革，既把坚持和加强党的领导作为进一步全面深化改革的政治引领和政治保障，又持续推进新时代党的建设新的伟大工程。</p>
        <p>完善党中央重大决策部署落实机制，健全防治形式主义、官僚主义制度机制，健全不正之风和腐败问题同查同治机制，丰富防治新型腐败和隐性腐败的有效办法……一系列重大举措，充分体现了持之以恒推进全面从严治党的坚定和清醒。</p>
        <p>改革潮起，击鼓催征。然而，如果不沉下心来抓落实，再好的目标，再好的蓝图，也只是镜中花、水中月。</p>
        <p>《决定》60条中的最后一条，突出强调“以钉钉子精神抓好改革落实”。各级领导干部一张蓝图绘到底、一茬接着一茬干，一定能把进一步全面深化改革的战略部署转化为推进中国式现代化的强大力量。</p>
        <p>是举旗定向的宣言书，也是攻坚克难的路线图。《决定》凝结着我们党对所处时代环境、风险挑战、战略方向的准确判断，凝结着对全面深化改革重大原则、总体目标、主攻方向的深刻把握，凝结着将改革进行到底的深谋远虑和决心勇气。</p>
        <p>站在历史的山巅回望，从开启改革开放和社会主义现代化建设新时期，到开启新时代全面深化改革、系统整体设计推进改革新征程，再到推动全面深化改革向广度和深度进军，三次“三中全会”一以贯之、一脉相承：</p>
        <p>——中国共产党人前行的决心矢志不渝。在各种风险考验面前，我们志不改、道不变，任尔东西南北风，不畏浮云遮望眼，把中国发展进步的命运牢牢掌握在自己手中。</p>
        <p>——始终坚持实事求是，目标笃定而蹄疾步稳。对于改革进程中已经出现和可能出现的问题，不搞“急就章”、不“画大饼”，而是困难一个一个克服、问题一个一个解决，既敢于出招又善于应招。</p>
        <p>——永远把老百姓的事情作为最重要的事情。坚持一切为了人民，以满足人民日益增长的美好生活需要为出发点和落脚点，把以人民为中心作为谋划推动改革、检验改革成果的逻辑起点与价值依归。</p>
        <p>——锻造坚强领导核心。始终保持以党的自我革命引领社会革命的高度自觉，坚持用改革精神和严的标准管党治党，确保我们党不断从胜利走向新的胜利。</p>
        <p>又踏层峰辟新天，更扬云帆立潮头。</p>
        <p>
          全党全军全国各族人民更加紧密地团结在以习近平同志为核心的党中央周围，全面贯彻落实党的二十届三中全会精神，不断将《决定》的“大写意”转化为“工笔画”“施工图”，进一步全面深化改革一定能蹄疾步稳，中国式现代化一定能阔步向前，中华民族伟大复兴一定展现出更加光明的前景！
        </p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'Build9' })">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;总书记在三中全会上的重要讲话发表，一起学习领悟！...</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build7' })">深刻把握“第二个结合”的精髓要义...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.content {
  width: 80%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }

  .blue01 {
    font-weight: bold;
    color: #000080;
  }
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}
</style>